import React, { createContext, useContext } from "react";

/** Libellé affiché quand l'athlète n'a pas de box / club, fourni au montage du planning des cycles */
export const NoCoordinateLabelContext = createContext("-");

export default function CfcRegistration({ cfcRegistration, cfcCycleUser, onClickOnDelete, onClickOnMoveLeft, onClickOnMoveRight, cfcCycle }) {
  const noCoordinateLabel = useContext(NoCoordinateLabelContext);

  return (
    <div>
      {cfcRegistration ? (
        <div className="mosaic__item" style={{ cursor: "move" }}>
          <div className="mosaic__section">
            <h4 className="mosaic__title">
              {cfcCycleUser ? `N°${cfcCycleUser.position} - ` : ""}
              {cfcRegistration.team_name ? `Team ${cfcRegistration.team_name}` : `${cfcRegistration.teams}`}
            </h4>
            {cfcRegistration.team_name ? <p className="mosaic__paragraph paragraph--small-font-size">{cfcRegistration.teams}</p> : ""}
            <div className="mosaic__badges">
              <div className="mosaic__badge mosaic__badge--small">{cfcRegistration.user.coordinate?.name || noCoordinateLabel}</div>
            </div>
            {cfcCycleUser ? (
              <div className="mosaic__buttons">
                {cfcCycleUser.position !== 1 ? (
                  <button className="mosaic__button mosaic__button--icon" onClick={onClickOnMoveLeft}>
                    <span className="material-icons">arrow_back</span>
                  </button>
                ) : (
                  ""
                )}
                <button className="mosaic__button mosaic__button--icon" onClick={onClickOnDelete}>
                  <span className="material-icons">delete</span>
                </button>
                {cfcCycleUser.position < cfcCycle.cfc_cycle_users.length ? (
                  <button className="mosaic__button mosaic__button--icon" onClick={onClickOnMoveRight}>
                    <span className="material-icons">arrow_forward</span>
                  </button>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}
